// SourceConfidence — compact confidence indicator for one cited source.
//
// Pierre's ask (2026-10-07): expose relevance signal to the user when the
// sources toggle is ON. Designer originally rejected raw scores (Q3: "noise
// to a GC"); compromise is qualitative band + numeric %, with a small dot
// meter so the signal is scannable without reading.
//
// Thresholds match the engine's retrieval minScore (0.6 cutoff).
//   >= 0.75 → "CLOSE MATCH" / ●●● / brand purple
//    0.6-0.75 → "RELATED"   / ●●○ / ink3 grey
//   < 0.6     → hidden (engine filters at 0.6; shouldn't reach here)

import { useI18n } from '../i18n/index.js';
import styles from './Coach.module.css';

export interface SourceConfidenceProps {
  score: number;
}

export function SourceConfidence({ score }: SourceConfidenceProps) {
  const { t } = useI18n();
  if (score < 0.6) return null;
  const high = score >= 0.75;
  const label = high ? t('sources.confidence.high') : t('sources.confidence.medium');
  const pct = `${Math.round(score * 100)}%`;
  return (
    <span
      className={`${styles.srcConfidence} ${high ? styles.srcConfidenceHigh : styles.srcConfidenceMedium}`}
      aria-label={`${label}, ${pct}`}
    >
      <span className={styles.srcConfidenceMeter} aria-hidden="true">
        <span className={styles.srcConfidenceDot} />
        <span className={styles.srcConfidenceDot} />
        <span className={high ? styles.srcConfidenceDot : styles.srcConfidenceDotEmpty} />
      </span>
      {label}
      <span className={styles.srcConfidencePct}>{pct}</span>
    </span>
  );
}
